import React, { useEffect } from 'react';
import { MultiTabMenu } from 'components/menus/MultiTabMenu';
import { BookingHistoryFiltersAndExport } from '../BookingHistoryFiltersAndExport';
import { DateSelectionSection } from '../DateSelectionSection';
import { LaundryBrikkModalContext } from '../../../LaundryBrikkModalContext';

export function BookResourceAndBookingExportSection({ laundryResources }) {

  const { setActiveTab } = React.useContext(LaundryBrikkModalContext);

  useEffect(() => {
    setActiveTab('bookingHistory');
  }, []);

  return (
    <MultiTabMenu
      title="laundryBrikk"
      defaultTab="bookAResource"
      tabs={{
        bookAResource: {
          title: '',
          component: () => (
            <DateSelectionSection
              laundryResources={laundryResources}
            />
          ),
          menus: [],
        },
        bookingHistory: {
          title: '',
          component: () => (
            <BookingHistoryFiltersAndExport />
          ),
          menus: [],
        },
      }}
      showOr={false}
    />
  );
}
